import { auth } from "app";
import { API_HOST, API_PATH, API_PREFIX_PATH } from "../constants";
import { Brain } from "./Brain";
import type { RequestParams } from "./http-client";

const isDeployedToCustomApiPath = API_PREFIX_PATH !== API_PATH;

const constructBaseUrl = (): string => {
  // Always use current domain + API path
  let domain = window.location.origin;
  
  // Defensive sanitization: fix double protocol if present
  if (domain.includes('https://https//') || domain.includes('http://http//')) {
    console.warn('⚠️ Malformed origin detected:', domain);
    domain = domain.replace(/https:\/\/https\/\//, 'https://').replace(/http:\/\/http\/\//, 'http://');
    console.log('✅ Sanitized origin:', domain);
  }
  
  const baseUrl = `${domain}${API_PATH}`;
  console.log('🌐 Brain baseUrl constructed:', baseUrl);
  return baseUrl;
};

type BaseApiParams = Omit<RequestParams, "signal" | "baseUrl" | "cancelToken">;

const constructBaseApiParams = (): BaseApiParams => {
  return {
    credentials: "include",
    secure: true,
  };
};

const constructClient = () => {
  const baseUrl = constructBaseUrl();
  const baseApiParams = constructBaseApiParams();

  return new Brain({
    baseUrl,
    baseApiParams,
    customFetch: async (url, options) => {
      // FIX: Only remove DUPLICATE /routes/routes/ not single /routes/
      // Some endpoints like places and qualifications need /routes/ prefix
      let finalUrl = url;
      
      // Only fix duplicate /routes/routes/ -> /routes/
      if (url.includes('/api/routes/')) {
        finalUrl = url.replace(/\/api\/routes\/routes\//g, '/api/');
      }
      
      // Get auth token
      const authHeader = await auth.getAuthHeaderValue();
      
      // Add auth to headers
      const modifiedOptions = {
        ...options,
        headers: {
          ...options?.headers,
          'Authorization': authHeader
        }
      };
      
      return fetch(finalUrl, modifiedOptions);
    },
    securityWorker: async () => {
      return {
        headers: {
          Authorization: await auth.getAuthHeaderValue(),
        },
      };
    },
  });
};

const brain = constructClient();

export default brain;
